
import { defineComponent } from 'vue'

import ProjectSection from './ProjectSection.vue'
import { ISection } from '../../interfaces/ISection'

export default defineComponent({
  name: 'ProjectViewer',
  components: {
    ProjectSection
  },
  props: {
    sections: {
      type: Array as () => ISection[],
      required: true
    },
    projectName: {
      type: String,
      required: true
    },
    categoryName: {
      type: String,
      required: true
    }
  },
  emits: ['delete-section'],
  setup(props, ctx) {
    return {
      onDeleteSection: () => ctx.emit('delete-section')
    }
  }
})
